import { VdsDivider, VdsLink } from '@volt/volt-extended-components-react';
import styles from './AccordionBody.module.scss';

interface AccordionBodyProps {
  title: string;
  description: string;
  url: string;
  linkTitle: string;
}

export const AccordionBody = ({ title, description, url, linkTitle }: AccordionBodyProps) => {
  return (
    <div className={styles.body}>
      <div className={styles.title}>{title}</div>
      <VdsDivider className={styles.divider} padding="spacing-00" />
      <div className={styles.content}>
        <div className={styles.description}>{description}</div>
        <VdsLink
          url={url}
          value={linkTitle}
          size="medium"
          target="_blank"
          rel="noopener noreferrer"
          variant="primary"
          informativeIcon="download"
          iconPosition="left"
        />
      </div>
    </div>
  );
};

export default AccordionBody;
